import React from "react";
import { useTranslation } from "react-i18next";
import "./loader.scss";

// Yagona yuklanish ko'rinishi (avvalgi Spin + "Ma'lumot yo'q" o'rniga)
export default function Loader({ text }) {
  const { t } = useTranslation();
  return (
    <div className="ln-loader" role="status" aria-live="polite">
      <span className="ln-loader__ring" aria-hidden="true">
        <span />
      </span>
      <span className="ln-loader__text">{text || t("Loading...")}</span>
    </div>
  );
}
